module.exports = __webpack_public_path__ + "media/images/flags/32/Tonga-e44d5fae8a26fc15337bc6c0cddd277d.png";